import { apiGet, apiPost } from "./api";

/** Crear Orden de Pago de Remitos */
export function postOrdenPagoRemito(payload) {
  return apiPost(`/ordenpagoremitos`, payload);
}

/** Listar OPR con filtros */
export function getOrdenesPagoRemitos({ proveedor, cliente, desde, hasta } = {}) {
  const q = new URLSearchParams();
  if (proveedor) q.set("proveedor", proveedor);
  if (cliente) q.set("cliente", cliente);
  if (desde) q.set("desde", desde);
  if (hasta) q.set("hasta", hasta);
  return apiGet(`/ordenpagoremitos${q.toString() ? "?" + q.toString() : ""}`);
}

/** Get por id */
export function getOrdenPagoRemitoById(id) {
  return apiGet(`/ordenpagoremitos/${id}`);
}

/** Anular */
export function anularOrdenPagoRemito(id) {
  return apiPost(`/ordenpagoremitos/${id}/anular`, {});
}
